import React, { useEffect } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { useLanguage } from './i18n/LanguageContext';
interface OpeningCurtainProps {
  onComplete: () => void;
}
const OPENING_ART_URL = 'https://cdn.magicpatterns.com/uploads/n9ZWvvsoT6MfTBo5CswnAN/CORTINA.png';
export function OpeningCurtain({
  onComplete
}: OpeningCurtainProps) {
  const shouldReduceMotion = useReducedMotion();
  const {
    t
  } = useLanguage();
  useEffect(() => {
    const timer = window.setTimeout(onComplete, shouldReduceMotion ? 120 : 2450);
    return () => window.clearTimeout(timer);
  }, [onComplete, shouldReduceMotion]);
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);
  return <motion.div role="status" aria-label={t.opening.aria} initial={{
    opacity: 1
  }} exit={{
    clipPath: shouldReduceMotion ? 'inset(0 0 0 0)' : 'inset(0 50% 0 50%)'
  }} transition={{
    duration: shouldReduceMotion ? 0.12 : 0.9,
    ease: [0.76, 0, 0.24, 1]
  }} className="fixed inset-0 z-[100] overflow-hidden bg-[#ede0ce]" data-id="element-365" data-mp="3lje5h2e5ggoo">
      <motion.div initial={{
      opacity: 0,
      scale: 0.97
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0.92,
      scale: 1.02
    }} transition={{
      duration: shouldReduceMotion ? 0.1 : 0.8,
      ease: [0.22, 1, 0.36, 1]
    }} className="absolute inset-0 flex items-center justify-center" data-id="element-366" data-mp="3vu9i31auznfc">
        <img src={OPENING_ART_URL} alt={t.opening.alt} className="h-[96svh] w-auto max-w-[96vw] object-contain md:h-[96svh]" data-id="element-367" data-mp="eczsci1g8fvn" />
      </motion.div>

      <motion.div aria-hidden="true" initial={{
      opacity: 0,
      scaleY: 0.15
    }} animate={{
      opacity: 1,
      scaleY: 1
    }} exit={{
      opacity: 0
    }} transition={{
      delay: shouldReduceMotion ? 0 : 0.28,
      duration: shouldReduceMotion ? 0.1 : 0.45,
      ease: [0.22, 1, 0.36, 1]
    }} className="absolute inset-y-0 left-1/2 z-10 w-px -translate-x-1/2 origin-center bg-gold/70" data-id="element-368" data-mp="ne7s74jm5oru" />

      <span aria-hidden="true" className="pointer-events-none absolute inset-3 border border-gold/20 sm:inset-5" data-id="element-369" data-mp="3nk9j3mjhgoyr" />
    </motion.div>;
}